/**
 * Static replacement data for the legacy Django screens.
 * Keep server-shaped data here until an API client replaces it.
 */
export type LegacyMenuItem = { label: string; path: string }
export type LegacyMenuGroup = { label: string; icon: string; items: LegacyMenuItem[] }

export const legacyMenus: LegacyMenuGroup[] = [
  {
    label: '고객 관리', icon: 'main_icon1', items: [
      { label: '신규 고객 등록', path: '/v1/customer/?CRUD=1' }, { label: '고객 목록', path: '/v1/customer_search/' },
      { label: '엑셀 데이터 입력', path: '/v1/excel/' }, { label: '고객 진행 내역', path: '/v1/customer/progress/page' },
      { label: '고객정보 작업기록', path: '/v1/customer_history/' },
    ],
  },
  {
    label: '스케줄', icon: 'main_icon2', items: [
      { label: '일 스케줄', path: '/v1/schedule/daily/' }, { label: '월 스케줄', path: '/v1/schedule/monthly/mock-office/2026/08/?is_first=Y' },
      { label: '업무 일지', path: '/v1/work_schedule?CRUD=2' }, { label: '스케줄 일괄 등록', path: '/v1/sched_one_q/' },
      { label: '스케줄 일괄 등록 내역', path: '/v1/sched_one_q_list/' }, { label: '고객 내용 프리셋 설정', path: '/v1/schedule_memo_preset/' },
    ],
  },
  {
    label: '문자 발송', icon: 'main_icon3', items: [
      { label: '문자 보내기', path: '/v1/sms_send/?un_limit=1' }, { label: '문자 발송 내역', path: '/v1/sms_result/' },
      { label: '문자 자동 발송 내역', path: '/v2/sms_auto_send_schedule/list/' }, { label: 'OOPS PUSH 내역', path: '/v1/push_msg_result_list/' },
      { label: '자주 사용하는 문자 설정', path: '/v1/sms_template/' }, { label: '문자 자동 발송 설정', path: '/v2/sms_auto_send_setting/list/' },
      { label: '시스템 문자 발송 설정', path: '/v1/schedule_change_sms_preset/' }, { label: '문자 발신 번호 설정', path: '/v1/callingnumberlist/' },
    ],
  },
  {
    label: '통계 / 현황', icon: 'main_icon4', items: [
      { label: '고객 환불 목록 (직접입력)', path: '/v1/refund_history/' }, { label: '고객 상담 목록', path: '/v2/customer_consult_list/' },
      { label: '촬영스케줄 등록 현황', path: '/v2/shoot-schedule-save-status/' }, { label: '매출 현황', path: '/v2/sales-status/' },
      { label: '총액/결제 통계', path: '/v1/sales_statistics' }, { label: '총액/결제 통계 상세', path: '/v1/statistics_by_counselor' },
      { label: '패키지 상품 계약 현황표', path: '/v2/package-contract-status/' }, { label: '촬영통계', path: '/v1/shooting_statistics' },
      { label: '방문동기 통계', path: '/v2/visit-status/' }, { label: '촬영테마 통계', path: '/v2/shoot-theme-status/' },
      { label: '상담자별 통계', path: '/v2/consultant-status/' },
    ],
  },
  {
    label: 'EDRP 사용료 관리', icon: 'main_icon5', items: [
      { label: '시스템 사용료 결제 내역', path: '/v2/system_usage_payment_list/' }, { label: '시스템 결제 카드 관리', path: '/v2/system_payment_card_manage/' },
      { label: '시스템 사용료 금액 설정', path: '/v1/setting_system_fee/' }, { label: '시스템 사용료 결제 내역 (관리자)', path: '/v1/history_system_fee/?type=admin&no_date_limit=Y' },
      { label: '시스템 사용료 결제 내역 (지점)', path: '/v1/history_system_fee/' }, { label: 'EDRP 사용 포인트 충전', path: '/office_amount_charges/' },
    ],
  },
  {
    label: '설정', icon: 'main_icon6', items: [
      { label: '패키지 상품 관리', path: '/v1/package/' }, { label: '상세 상품 관리', path: '/v1/detail_package/' },
      { label: '상세 상품 일괄 등록', path: '/v1/detail_package/bulk_save/' }, { label: '스케줄 상태 설정', path: '/schedule_state_setting/' },
      { label: '직원 담당업무 설정', path: '/v1/new/manager/list/' }, { label: '그룹 관리', path: '/v1/group/' },
      { label: '지점 관리', path: '/v1/branch_office_care/' }, { label: '직원 등록/수정', path: '/staff_list/' },
      { label: '상품 제작업체 관리', path: '/v1/product_vender/' }, { label: 'TM 스케줄 항목 설정', path: '/v1/tm_sched_category/' },
      { label: '색상 설정', path: '/v1/color/' }, { label: '촬영 작업담당 관리', path: '/v1/photo_schedule/workgroup' },
      { label: '작업실 관리', path: '/v1/workroom' }, { label: '고객구분 설정', path: '/v1/customer_soratation_registration/' },
      { label: '방문동기 관리', path: '/v1/customer_visit_integration/' }, { label: '계약 동의 내용 관리', path: '/v1/contract/content/view' },
      { label: 'TM 엑셀 업로드', path: '/v1/tm_excel/upload' }, { label: '일반일정 엑셀 업로드', path: '/v1/general_schedule/upload' },
      { label: '계약 상품 일괄 변경', path: '/v1/smmate/contract/product/page' }, { label: '촬영스케줄 일괄 변경', path: '/v1/photo_schedule/change' },
      { label: '스토리지 현황', path: '/v2/storage_status/' }, { label: '스토리지 정리', path: '/v2/storage_cleanup/' },
      { label: '비밀번호 변경', path: '/staff_change_password/mock-user/' }, { label: '내 정보 수정', path: '/v2/my_info_save/' },
    ],
  },
  {
    label: '시스템관리', icon: 'main_icon7', items: [
      { label: '시스템 사용료 관리', path: '/v2/admin/system_usage_payment_list/' }, { label: '공휴일 관리', path: '/v1/system/holiday/view' },
      { label: 'SMMATE 데이타 변환', path: '/v2/admin/data_convert_smmate/' }, { label: '권한관리', path: '/v2/auth-manage' },
    ],
  },
]

export const legacyRecentCustomers = [
  { no: 'C-24081', names: '김지현 · 김서윤' },
  { no: 'C-24080', names: '이은서 · 이하준' },
]

export const legacySidebarRecentResults = [
  { no: 'C-000003', parent: '고객 A', baby: '아기 A', phone: '010-0000-0003' },
  { no: 'C-000002', parent: '고객 B', baby: '아기 B', phone: '010-0000-0002' },
  { no: 'C-000001', parent: '고객 C', baby: '아기 C', phone: '010-0000-0001' },
]

export const legacyCustomers = [
  { no: 'C-24081', parent: '김지현', baby: '김서윤', phone: '010-4231-8765', office: '강남점', date: '2026-08-19' },
  { no: 'C-24080', parent: '이은서', baby: '이하준', phone: '010-9874-1320', office: '강남점', date: '2026-08-19' },
  { no: 'C-24079', parent: '박수아', baby: '박도현', phone: '010-3349-5581', office: '잠실점', date: '2026-08-18' },
]
